import { z } from "zod";
export var PortalFeature;
(function (PortalFeature) {
    PortalFeature["ADMIN"] = "admin";
    PortalFeature["CBM"] = "cbm";
    PortalFeature["CBM_UTILIZATION"] = "cbm_utilization";
    PortalFeature["CII"] = "cii";
    PortalFeature["CONSUMPTION_TIMELINE_BASELINE"] = "consumption_timeline_baseline";
    PortalFeature["DATABASE"] = "database";
    PortalFeature["DOCUMENTS"] = "documents";
    PortalFeature["DOWNLOAD_VIRTUAL_SENSOR_DATA"] = "download_virtual_sensor_data";
    PortalFeature["EMISSIONS_ANALYSIS"] = "emissions analysis";
    PortalFeature["EQUIPMENT_MANUFACTURER"] = "equipment_manufacturer";
    PortalFeature["EQUIPMENT_USAGE"] = "equipment_usage";
    PortalFeature["EU_ETS"] = "eu_ets";
    PortalFeature["FACILITIES"] = "facilities";
    PortalFeature["FISH_FARM"] = "fish_farm";
    PortalFeature["FISH_KPIS"] = "fish_kpis";
    PortalFeature["FREIGHTLETTER"] = "freightletter";
    PortalFeature["FUEL_CONSUMPTION"] = "fuel consumption";
    PortalFeature["FUEL_EU"] = "fuel_eu";
    PortalFeature["HULL_FOULING"] = "hull_fouling";
    PortalFeature["MACHINERY"] = "machinery";
    PortalFeature["MAP"] = "map";
    PortalFeature["MRV"] = "mrv";
    PortalFeature["NOTES"] = "notes";
    PortalFeature["OIL_AND_GAS"] = "oil_and_gas";
    PortalFeature["OPERATION_TIMELINE"] = "operation_timeline";
    PortalFeature["OPMODES"] = "opmodes";
    PortalFeature["REPORTS"] = "reports";
    PortalFeature["SEEMP"] = "seemp";
    PortalFeature["SENSOR_DATA_DOWNLOAD"] = "sensor_data_download";
    PortalFeature["SENSORDATA"] = "sensordata";
    PortalFeature["SHOW_DATALESS_PLANTS"] = "show_dataless_plants";
    PortalFeature["SPECTRO_DATA"] = "spectro_data";
    PortalFeature["SUBCLIENTS"] = "subclients";
    PortalFeature["TIMELINE"] = "timeline";
    PortalFeature["VESSEL_CONNECTION_STATUS"] = "vessel_connection_status";
    PortalFeature["VESSEL_KPIS"] = "vessel_kpis";
    PortalFeature["VESSEL_STATUS"] = "vessel_status";
    PortalFeature["VESSELS_TRACK"] = "vessels_track";
    PortalFeature["VOYAGE_PLANNING"] = "voyage planning";
    PortalFeature["WATER_QUALITY_KPIS"] = "water_quality_kpis";
    PortalFeature["WEATHER"] = "weather";
})(PortalFeature || (PortalFeature = {}));
export const PortalFeatureEnum = z.string();
//# sourceMappingURL=PortalFeature.js.map